// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"d52b2a24","309":"c5ff8ee9","392":"af5b6077","576":"81c1fc39","714":"dba3d8a8","743":"807166a2","787":"0d66e12a","790":"d65d569b","892":"bb955acf","918":"2a6840c8","940":"70a9f43d"}[chunkId] + ".chunk.js";
};